export enum DataLeakTypeValue {
  ACCOUNT = "account",
  COOKIE = "cookie",
  EMAIL = "email",
  SOURCE_CODE = "source_code",
}
